import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { OrganizationSettingsViewTopBar } from "./TopBar"

export const organizationSettingsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: OrganizationSettingsViewTopBar,
}
